'use strict'

const { createImmediateCmd } = require('redux-serial-effects')

const TYPE = 'FIRE_EVENT'
const executor = (fireEvent, errorBoundaries) => ({
  type: TYPE,
  execute: cmd => {
    return errorBoundaries.userCodeZone(fireEvent)(cmd.type, ...cmd.payload)
  }
})

const fireEventCmd = (type, ...payload) =>
  createImmediateCmd(TYPE, {
    type,
    payload
  })

module.exports.executor = executor

module.exports.fireEventCmd = fireEventCmd



// WEBPACK FOOTER //
// ./helpers/fireEventExecutor.js